import { render, staticRenderFns } from "./imgX.vue?vue&type=template&id=d1d9e88e"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1d9e88e')) {
      api.createRecord('d1d9e88e', component.options)
    } else {
      api.reload('d1d9e88e', component.options)
    }
    module.hot.accept("./imgX.vue?vue&type=template&id=d1d9e88e", function () {
      api.rerender('d1d9e88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgX.vue"
export default component.exports